import { render, staticRenderFns } from "./scCountdown.vue?vue&type=template&id=2387581a&scoped=true&"
import script from "./scCountdown.vue?vue&type=script&lang=js&"
export * from "./scCountdown.vue?vue&type=script&lang=js&"
import style0 from "./scCountdown.vue?vue&type=style&index=0&id=2387581a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2387581a",
  null
  
)

export default component.exports